module.exports = __webpack_public_path__ + "img/banner.23fd9db8.jpg";